var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStablecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.626,
    height: 33.851,
    viewBox: "0 0 27.626 33.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.813 32.851C28.771 27.986 26.446 6.717 26.446 6.717 17.213 6.211 13.813 1 13.813 1s-3.4 5.212-12.632 5.717c0 0-2.325 21.269 12.632 26.134z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.922 11.153)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.892,
    cy: 5.892,
    r: 5.892
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.404 5.773l2.158 2.018 3.045-3.126"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStablecoin);
export default __webpack_public_path__ + "static/media/stablecoin.e7a06724b38d92b634c999cc958a1050.svg";
export { ForwardRef as ReactComponent };